<template>
    <div class="block-share">
        <ui-social class="block-share__button" type="vk" @click.native="share('vk')" />
        <ui-social class="block-share__button" type="fb" @click.native="share('fb')" />
        <ui-social class="block-share__button" type="tw" @click.native="share('tw')" />
        <ui-social class="block-share__button block-share__button--last" type="ok" @click.native="share('ok')" />
    </div>
</template>

<script>
    import Share from '@/utils/share'
    export default {
        props: {
            url: {
                type: String,
                default: ''
            }
        },
        methods: {
            share (type) {
                Share.open(type, {url: this.url})
                window.ym(53131834, 'reachGoal', 'ebay_' + type)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .block-share {
        &__button {
            margin-top 2px
            margin-right 2.9rem
            color $color-light
            transition color 0.3s ease, transform 0.3s ease

            &--last {
                margin-right 0
            }

            &:hover {
                color #629cff
                transform scale(1.1)
            }

            &:active {
                opacity 0.7
            }
        }

    }
</style>
